import { useOnboardingStep } from "@/context/OnboardingStepProvider/OnboardingStepProvider";
import { cn } from "@/lib/utils";
import { useMemo } from "react";

export const OnboardingDotStepper = ({
  value,
  max,
}: {
  value?: number;
  max?: number;
}) => {
  const { currentStep, totalSteps } = useOnboardingStep();

  const current = value ?? currentStep;
  const maximum = max ?? totalSteps;

  const stepsArray = useMemo(() => [...Array(maximum).keys()], [maximum]);

  return (
    <div className="flex gap-x-2">
      {stepsArray.map((step) => (
        <div
          key={step}
          className={cn(
            "flex items-center justify-center ring size-5 my-2 bg-transparent rounded-full transition-all duration-500",
            step === current
              ? "w-12 ring-2 ring-white"
              : "ring-1 ring-white/24",
          )}
        >
          <span
            className={cn(
              "block w-[2.375rem] h-[0.625rem] bg-white rounded-full transition-all duration-500",
              step === current ? "w-[2.375rem] h-[0.625rem]" : "w-0 h-0",
            )}
          />
        </div>
      ))}
    </div>
  );
};
